/**
 * The Chinese site (1.04.4, the owner, 26 October 2026: "the chinese directs to cn.trenchio.gg and everything in
 * chinese, unless they change it to english on cn.trenchio.gg, which then english becomes avaulable on
 * cn.Trenchio.Gg"): cn.<the site's domain>, the China entrance's own https name (deploy_relay.sh <main> China
 * cn.trenchio.gg). There the page is in Chinese unless English is picked there, and only those two are offered; picking
 * Chinese anywhere else opens it.
 */

/** whether a page is on the Chinese site (its address starts with cn.) */
export const onChineseSite = (hostname: string): boolean => /^cn\./iu.test(hostname);

const IPV4 = /^\d{1,3}(?:\.\d{1,3}){3}$/u;

/**
 * Where picking Chinese takes a player: an entrance at cn.<domain> the server lists (its https address), else
 * https://cn.<the site's domain> (the main address the server gives, else this page's, without www.). Undefined on a
 * machine's own address (an IP, localhost, a name without a dot): there's no Chinese site there, so the language
 * changes on the page itself
 */
export function chineseSiteOrigin(hostname: string, mainSite?: string, entrances: readonly string[] = []): string | undefined {
    for (const url of entrances) {
        try {
            const entrance = new URL(url);
            if (entrance.protocol === "https:" && onChineseSite(entrance.hostname)) return entrance.origin;
        } catch {
            /* (not an address) */
        }
    }
    let host = hostname.toLowerCase();
    try {
        const main = mainSite ? new URL(mainSite) : undefined;
        if (main?.protocol === "https:") host = main.hostname.toLowerCase();
    } catch {
        /* (not an address: this page's own) */
    }
    if (!host.includes(".") || IPV4.test(host) || host.startsWith("[") || host.endsWith(".localhost")) return undefined;
    if (host.startsWith("www.")) host = host.slice(4);
    return onChineseSite(host) ? `https://${host}` : `https://cn.${host}`;
}

/**
 * Whether a site answers at all (its name leads somewhere, with a certificate the browser takes), asked before a
 * player is sent there: a Chinese site that isn't set up yet would be a page that doesn't open. Whatever it answers
 * counts (the answer itself can't be read from here); nothing within `waitMs`, or no connection, is no
 */
export async function siteAnswers(origin: string, waitMs = 4000): Promise<boolean> {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), waitMs);
    try {
        await fetch(`${origin}/api/serverInfo`, { mode: "no-cors", cache: "no-store", credentials: "omit", signal: controller.signal });
        return true;
    } catch {
        return false;
    } finally {
        clearTimeout(timer);
    }
}
